import { AppBar, useLoading, useRefresh } from "react-admin";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { HiOutlineRefresh } from "react-icons/hi";
import { AppUserMenu } from "./AppMenus";
import { useEffect } from "react";
import { colors } from "../data/tokens";

const textColor = colors.textMuted;
const Logo = () => (
  <img
    alt="Clube de engenharia Logo"
    src="/logo-horizontal.svg"
    // display block evita o vão de baseline; a toolbar centraliza na vertical
    style={{ width: 180, display: "block" }}
  />
);

// Substitui o LoadingIndicator padrão do react-admin (escondido via CSS
// abaixo) pelo mesmo papel com ícone da família Heroicons da sidebar:
// clique = atualizar os dados da tela; girando = requisição em andamento
const RefreshButton = () => {
  const refresh = useRefresh();
  const loading = useLoading();
  return (
    <Tooltip title="Atualizar dados">
      <IconButton
        onClick={() => refresh()}
        size="small"
        sx={{ color: textColor, marginRight: "4px" }}
      >
        {loading ? (
          <CircularProgress
            size={18}
            thickness={5}
            sx={{ color: textColor }}
          />
        ) : (
          <HiOutlineRefresh size={20} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export function AppNavbar() {
  useEffect(() => {
    // find element with class containing "css-<RANDOMSTRING>-RaLayout-root" and remove this class from element
    // this class somehow affects scroll on tables
    if (localStorage.getItem("isMobile") === "true") {
      const layout = document.querySelector("[class*='RaLayout-root']");
      if (layout) {
        // console.log("test classList", layout.classList);
        const classIndex = Array.from(layout.classList).findIndex((c) =>
          c.startsWith("css-")
        );
        layout.classList.remove(layout.classList[classIndex]);
      }
    }
  }, []);
  return (
    <AppBar
      alwaysOn // barra fixa: não esconde ao rolar a página
      // place custom styles here
      sx={{
        color: textColor,
        background: "white",
        // place toolbar-custom styles here
        "& .RaAppBar-toolbar": { padding: "0 12px", color: textColor },
        // place menu-custom styles here
        "& .RaAppBar-menuButton": { color: textColor },
        // esconde o LoadingIndicator padrão — o RefreshButton o substitui
        // (nesta versão do RA o contêiner não tem classe própria; as
        // classes ficam no ícone e no spinner internos)
        "& .RaLoadingIndicator-loadedIcon, & .RaLoadingIndicator-loader": {
          display: "none",
        },
      }}
      userMenu={<AppUserMenu />}>
      {/* Logo direto na barra — sem o TitlePortal, o header não exibe
          mais o título da página (o breadcrumb já cumpre esse papel) */}
      <Logo />
      <span style={{ flex: 1 }} />
      <RefreshButton />
    </AppBar>
  );
}
